import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSiteSettings } from '../SiteSettingsContext';
import { initGA, resolveGa4MeasurementId, trackPageView } from '../analytics';

/** Loads GA4 when a measurement ID is configured; tracks SPA page views. */
export default function Ga4Init() {
  const { settings: site } = useSiteSettings();
  const location = useLocation();

  useEffect(() => {
    const id = resolveGa4MeasurementId(site);
    if (!id) return;
    if (initGA(id)) {
      const path = `${location.pathname}${location.search}${location.hash}`;
      trackPageView(path);
    }
  }, [site, location.pathname, location.search, location.hash]);

  return null;
}
